var _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMilestoneLastPath(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 322,
    viewBox: "0 0 16 322",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 3.49691e-7,
    x2: 7.99999,
    y2: 250,
    stroke: "#97999B",
    strokeWidth: 16,
    strokeDasharray: "16 16"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilestoneLastPath);
export default __webpack_public_path__ + "static/media/milestoneLastPath.671e32239f9668cb6f00c8066e2516a7.svg";
export { ForwardRef as ReactComponent };